import React, { FC } from 'react'

import { getVariantsKeyFromAttribute, Product, VariantAttributeKey } from '../../../../lib/products'
import * as Styled from './styled'

type ProductAttributesProps = {
  product: Product
}

export const ProductAttributes: FC<ProductAttributesProps> = ({ product }) => {
  const variantAttributes = (product.variants?.summary.attributes || []).map<VariantAttributeKey>(
    (attribute) => getVariantsKeyFromAttribute(attribute),
  )

  return (
    <>
      {variantAttributes.map((attributeKey, index) => {
        const values = product.variants?.summary.values[attributeKey] || []
        return (
          values.length > 0 &&
          attributeKey === 'dosage' && (
            <Styled.DosageTag key={`${product.urlKey}-${attributeKey}-${index + 1}`}>
              {values.join(' / ')}
            </Styled.DosageTag>
          )
        )
      })}
      {variantAttributes.map((attributeKey, index) => {
        const values = product.variants?.summary.values[attributeKey] || []
        return (
          values.length > 0 &&
          (attributeKey === 'flavorSize' || attributeKey === 'flavor') && (
            <Styled.ProductAttribute key={`${product.urlKey}-${attributeKey}-${index + 1}`}>
              {values.join(' / ')}
            </Styled.ProductAttribute>
          )
        )
      })}
      {variantAttributes.map((attributeKey) => {
        const values = product.variants?.summary.values[attributeKey] || []
        return values.length > 0 && attributeKey === 'size' ? (
          <Styled.ScrollableContainer key={`${attributeKey}-container`}>
            {values.map((value, index) => (
              <Styled.SizeTag key={`${product.urlKey}-${attributeKey}-${index + 1}`}>
                {value}
              </Styled.SizeTag>
            ))}
          </Styled.ScrollableContainer>
        ) : null
      })}
    </>
  )
}
